export const FETCH_LICENSING_LINK = 'FETCH_LICENSING_LINK' as const;
export const FETCH_LICENSING_LINK_SUCCESS = 'FETCH_LICENSING_LINK_SUCCESS' as const;
export const FETCH_LICENSING_LINK_FAIL = 'FETCH_LICENSING_LINK_FAIL' as const;
export const FETCH_LICENSING_LINK_CANCEL = 'FETCH_LICENSING_LINK_CANCEL' as const;
export const CLEAR_LICENSING_LINK = 'CLEAR_LICENSING_LINK' as const;

export const FETCH_IMPERSONATION_LINK = 'FETCH_IMPERSONATION_LINK' as const;
export const FETCH_IMPERSONATION_LINK_SUCCESS = 'FETCH_IMPERSONATION_LINK_SUCCESS' as const;
export const FETCH_IMPERSONATION_LINK_FAIL = 'FETCH_IMPERSONATION_LINK_FAIL' as const;
export const FETCH_IMPERSONATION_LINK_CANCEL = 'FETCH_IMPERSONATION_LINK_CANCEL' as const;
export const CLEAR_IMPERSONATION_LINK = 'CLEAR_IMPERSONATION_LINK' as const;
